<div
  class="modal fade cookie-consent-modal-root"
  id="consentModal"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="view === 'main' ? 'consentModalTitle' : 'consentCustomizeTitle'"
  aria-hidden="true"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable cookie-consent-modal"
    [class.cookie-consent-modal--main]="view === 'main'"
    [class.cookie-consent-modal--customize]="view === 'customize'"
  >
    <div class="modal-content cookie-consent-modal__content">
      @if (view === 'main') {
        <div class="cookie-consent-modal__panel cookie-consent-modal__panel--main">
          <h2 id="consentModalTitle" class="visually-hidden">Preferencias de cookies</h2>

          <button
            type="button"
            class="cookie-consent-modal__close"
            aria-label="Rechazar cookies y cerrar"
            (click)="onCloseMain()"
          >
            <svg class="cookie-consent-modal__close-icon" viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M6 6L18 18M18 6L6 18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </button>

          <div
            class="cookie-consent-modal__icon cookie-consent-modal__icon--main"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M12 4.5L20.5 19.5H3.5L12 4.5Z"
                stroke="currentColor"
                stroke-width="1.75"
                stroke-linejoin="round"
              />
              <path
                d="M12 10V14"
                stroke="currentColor"
                stroke-width="1.75"
                stroke-linecap="round"
              />
              <circle cx="12" cy="17" r="1" fill="currentColor" />
            </svg>
          </div>

          <div class="cookie-consent-modal__body">
            <p class="cookie-consent-modal__text">
              @for (segment of textSegments; track trackSegment($index, segment)) {
                @if (segment.isPolicyLink) {
                  @if (policyUrl) {
                    <a
                      class="cookie-consent-modal__policy-link"
                      [href]="policyUrl"
                      target="_blank"
                      rel="noopener noreferrer"
                      >{{ segment.text }}</a
                    >
                  } @else {
                    <span class="cookie-consent-modal__policy-link">{{ segment.text }}</span>
                  }
                } @else {
                  <span [innerHTML]="segmentHtml(segment)"></span>
                }
              }
            </p>
          </div>

          <div class="cookie-consent-modal__actions cookie-consent-modal__actions--main">
            <button
              type="button"
              class="cookie-consent-modal__btn cookie-consent-modal__btn--primary"
              (click)="onAcceptAll()"
            >
              Aceptar
            </button>
            <button
              type="button"
              class="cookie-consent-modal__btn cookie-consent-modal__btn--outline"
              (click)="onRejectAll()"
            >
              Rechazar
            </button>
            <button
              #personalizarBtn
              type="button"
              class="cookie-consent-modal__btn cookie-consent-modal__btn--outline"
              (click)="openCustomize()"
            >
              Personalizar
            </button>
          </div>
        </div>
      }

      @if (view === 'customize') {
        <div class="cookie-consent-modal__panel cookie-consent-modal__panel--customize">
          <h2 id="consentCustomizeTitle" class="visually-hidden">Configurar cookies</h2>

          <button
            type="button"
            class="cookie-consent-modal__close"
            aria-label="Regresar sin guardar cambios"
            (click)="onCloseCustomize()"
          >
            <svg class="cookie-consent-modal__close-icon" viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M6 6L18 18M18 6L6 18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </button>

          <div
            class="cookie-consent-modal__icon cookie-consent-modal__icon--customize"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M12 4.5L20.5 19.5H3.5L12 4.5Z"
                stroke="currentColor"
                stroke-width="1.75"
                stroke-linejoin="round"
              />
              <path
                d="M12 10V14"
                stroke="currentColor"
                stroke-width="1.75"
                stroke-linecap="round"
              />
              <circle cx="12" cy="17" r="1" fill="currentColor" />
            </svg>
          </div>

          <div
            class="cookie-consent-modal__checkbox-list"
            role="group"
            aria-label="Servicios de cookies configurables"
          >
            @for (provider of customizeProviders; track provider.id) {
              <label class="cookie-consent-modal__checkbox">
                <input
                  #customizeCheckbox
                  type="checkbox"
                  class="cookie-consent-modal__checkbox-input"
                  [checked]="isDraftAccepted(provider.id)"
                  (change)="onDraftCheckboxChange(provider.id, $event)"
                />
                <span class="cookie-consent-modal__checkbox-label">{{ provider.label }}</span>
              </label>
            }
          </div>

          <div class="cookie-consent-modal__actions cookie-consent-modal__actions--customize">
            <button
              type="button"
              class="cookie-consent-modal__btn cookie-consent-modal__btn--primary cookie-consent-modal__btn--compact"
              (click)="onSavePreferences()"
            >
              Aceptar
            </button>
            <button
              type="button"
              class="cookie-consent-modal__btn cookie-consent-modal__btn--outline cookie-consent-modal__btn--compact"
              (click)="onCloseCustomize()"
            >
              Regresar
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</div>

@if (open) {
  <div class="modal-backdrop fade show cookie-consent-modal__backdrop"></div>
}
